// @ts-expect-error legacy-hubspot-bender-context is a virtual, undeclared module
import { bender } from 'legacy-hubspot-bender-context';
import { Level, LogHandler } from 'simple-logging-lib';
import { captureException } from '../utils/sentryAPI';
import { getErrorContext } from './getErrorContext';
export class ErrorLogHandler extends LogHandler {
  constructor(...args) {
    super(...args);
    this.level = Level.ERROR;
  }
  publish(record) {
    if (!this.isLoggable(record)) {
      return;
    }
    const {
      loggerName,
      messages
    } = record;
    console.error(`%c[${loggerName}]`, 'color: #444; font-weight: bold;', ...messages);
    const [maybeError, options] = messages;
    if (maybeError instanceof Error) {
      this.reportError(maybeError, options);
    }
  }
  reportError(error, options = {}) {
    const version = bender.depVersions[bender.project];
    const tags = {
      version
    };
    const errorContext = getErrorContext(error);
    const {
      extra,
      fingerprint,
      tags: errorTags
    } = errorContext !== null && errorContext !== void 0 ? errorContext : {};
    captureException(error, Object.assign({}, options, {
      extra: Object.assign({}, options.extra, extra),
      tags: Object.assign({}, tags, errorTags),
      fingerprint
    }));
  }
}